import { useLang } from "@/context/LanguageContext";
import { CountUp } from "@/components/site/CountUp";
import { RevealGroup, RevealItem } from "@/components/site/Reveal";

export const TrustBar = () => {
  const { t } = useLang();
  return (
    <section className="relative z-10 -mt-px bg-forest text-cream" data-testid="trust-bar">
      <div className="noise pointer-events-none absolute inset-0 opacity-[0.04]" />
      <div className="container-x relative py-14 lg:py-16">
        <RevealGroup className="grid grid-cols-2 gap-x-6 gap-y-12 lg:grid-cols-4">
          {t.trust.items.map((item, i) => (
            <RevealItem key={i} className="relative text-center lg:text-start">
              <div className="font-display text-5xl font-extrabold tracking-tight text-gold-light lg:text-6xl">
                <CountUp end={item.value} suffix={item.suffix} animate={item.animate !== false} />
              </div>
              <p className="mt-3 text-sm text-cream/70">{item.label}</p>
              {i < 3 && (
                <span className="absolute end-0 top-1/2 hidden h-16 w-px -translate-y-1/2 bg-cream/15 lg:block" />
              )}
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
};
